import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section11Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const PressSection = ({ job, page, section, ...props }: Section11Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Appearances && (
          <div className="flex flex-col items-center justify-center gap-10 lg:flex-row">
            {section?.Appearances?.map((item: any) => {
              if (!item?.Image?.data) {
                return null;
              }

              return (
                <Link className="block" href={item?.Url ?? ""} key={item?.id} variant="external">
                  <Image
                    alt={item?.Image?.data?.attributes?.alternativeText}
                    src={item?.Image?.data?.attributes?.url}
                    height={item?.Image?.data?.attributes?.height ?? "100"}
                    width={item?.Image?.data?.attributes?.width ?? "100"}
                  />
                </Link>
              );
            })}
          </div>
        )}
        {section?.Button && (
          <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
            <Button className="mx-auto" size="large">
              {section?.Button?.Value}
            </Button>
          </Link>
        )}
      </SectionContainer>
    </Section>
  );
};

export default PressSection;
